import { render, staticRenderFns } from "./BtnDefault.vue?vue&type=template&id=1a6d36a7&"
import script from "./BtnDefault.vue?vue&type=script&lang=js&"
export * from "./BtnDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports